export default Object.freeze({
  CREATED: 'created',
  PROCESSING: 'processing',
  PROCESSED: 'processed',
});
